var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrashRedIcon = function SvgTrashRedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.649 9.91a1.5 1.5 0 0 1 1.495-1.615h11.448a1.5 1.5 0 0 1 1.496 1.615l-.818 10.638a1.5 1.5 0 0 1-1.496 1.385H6.963a1.5 1.5 0 0 1-1.496-1.385L4.65 9.91Z",
    stroke: "#E14851",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.737 5.148H4",
    stroke: "#E14851",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77 3a1 1 0 0 1 1-1h2.197a1 1 0 0 1 1 1v2.147H9.77V3Z",
    stroke: "#E14851",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.967 12.491v5.246M9.77 12.491v5.246",
    stroke: "#E14851",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

export { SvgTrashRedIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNjQ4ODMgOS45MDk1NkM0LjU4MTgyIDkuMDM4MzYgNS4yNzA2NSA4LjI5NDUxIDYuMTQ0NDEgOC4yOTQ1MUgxNy41OTI1QzE4LjQ2NjIgOC4yOTQ1MSAxOS4xNTUxIDkuMDM4MzYgMTkuMDg4MSA5LjkwOTU1TDE4LjI2OTcgMjAuNTQ4MUMxOC4yMDk2IDIxLjMyOTYgMTcuNTU3OSAyMS45MzMxIDE2Ljc3NDEgMjEuOTMzMUg2Ljk2Mjc3QzYuMTc4OTYgMjEuOTMzMSA1LjUyNzMgMjEuMzI5NiA1LjQ2NzE4IDIwLjU0ODFMNC42NDg4MyA5LjkwOTU2WiIgc3Ryb2tlPSIjRTE0ODUxIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTkuNzM2OCA1LjE0NzUySDQiIHN0cm9rZT0iI0UxNDg1MSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS43NzAyIDNDOS43NzAyIDIuNDQ3NzIgMTAuMjE3OSAyIDEwLjc3MDIgMkgxMi45NjY3QzEzLjUxOSAyIDEzLjk2NjcgMi40NDc3MiAxMy45NjY3IDNWNS4xNDczNkg5Ljc3MDJWM1oiIHN0cm9rZT0iI0UxNDg1MSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTEzLjk2NjYgMTIuNDkxMlYxNy43MzY4IiBzdHJva2U9IiNFMTQ4NTEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTkuNzcwMiAxMi40OTEyVjE3LjczNjgiIHN0cm9rZT0iI0UxNDg1MSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";